/**
 *  Imports
 */
import axios from 'axios';

// const getURLParameter = (qrString, paramName) => {
//   qrString = qrString.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
//   var regex = new RegExp('[\\?&]' + paramName + '=([^&#]*)');
//   var results = regex.exec(qrString);


//   if (results && results.length > 0) {
//     return decodeURIComponent(results[1].replace(/\+/g, ' '));
//   } else {
//     return '';
//   }
// }
var accesstoken = localStorage.getItem('accessToken');
/**
 *  Function to create body via form data
 */

/**
 *  API call via Promise
 */
const apiCall = ({
	method = "POST",
	url,
	body = {}
}) => {
  	function apiPromise(token) {
		const headers = {
			'Content-Type': 'application/json',
		  }
		if (token) headers["Authorization"] = token;
		if (localStorage.getItem('access_token')) headers["token"] = localStorage.getItem('access_token');
		let params = {
			params : { ...body}
		}
		if (method === "POST") {
			return axios.post('https://api.scanpay.in/neighbor_good_card/'+url, params,  {
				headers: headers
			  })
		}else {
			return axios.get(url, {}, headers)
		}
	}

	return apiPromise()
		.then(res => res)
		.catch(err => {
		return "error";
	});
};

export default apiCall;